import { RootState } from '../index';
import { TeamSpaceInfo, TeamRole } from '../slices/spaceSlice';

/** 当前空间（null = 个人空间） */
export const selectCurrentSpace = (state: RootState): TeamSpaceInfo | null =>
  state.space.current;

/** 是否团队空间 */
export const selectIsTeamSpace = (state: RootState): boolean => state.space.current !== null;

/** 个人账号 user_id（画布 creator_user_id 比对用） */
export const selectPersonalUserId = (state: RootState): string | null =>
  state.space.personalUserId;

/** 当前身份：personal / team-member / team-owner（PRD 1.4 三态） */
export type SpaceIdentity = 'personal' | 'team-member' | 'team-owner';

export const selectIdentity = (state: RootState): SpaceIdentity => {
  const current = state.space.current;
  if (!current) return 'personal';
  return current.role === TeamRole.Owner ? 'team-owner' : 'team-member';
};
